import { Rating } from './types';

class RatingHelper {
  static toRounded(rating: number, nrOfDecimals = 1) {
    return parseFloat(rating.toFixed(nrOfDecimals));
  }

  static toRoundedString(rating: number, nrOfDecimals = 1) {
    return rating.toFixed(nrOfDecimals);
  }

  static toHalf(rating: number) {
    return Math.ceil(RatingHelper.toRounded(rating) * 2) / 2;
  }

  static toWhole(rating: number) {
    return Math.ceil(RatingHelper.toRounded(rating));
  }

  static convert(rating: number, nrOfDecimals = 1): Rating {
    return {
      real: rating,
      rounded: RatingHelper.toRounded(rating, nrOfDecimals),
      roundedString: RatingHelper.toRoundedString(rating, nrOfDecimals),
      half: RatingHelper.toHalf(rating),
      whole: RatingHelper.toWhole(rating),
    };
  }
}

export default RatingHelper;
